import React, {useState} from 'react';

import {
  ActionsButton,
  ActionsMenuItemsType,
} from 'app/general/widgets/ActionsButton';
import {useBulkRevokeTasks} from 'app/tasks/api';
import {gt} from 'app/utils/i18n';

import {CancelTaskModal} from './CancelTaskModal';

import {ReassignTaskModal} from '../AssignTaskModal';

import {SlimTaskInstanceSerializedType} from 'sweet-types';

interface Props {
  task: SlimTaskInstanceSerializedType;
}

export function CompactTaskItemActionsButton({
  task,
}: Props): JSX.Element | null {
  const [reassignModal, setReassignModal] = useState<null | {
    task: SlimTaskInstanceSerializedType;
    visible: boolean;
  }>(null);
  const [cancelModal, setCancelModal] = useState<null | {
    task: SlimTaskInstanceSerializedType;
    visible: boolean;
  }>(null);

  const [bulkRevokeTasksAccess] = useBulkRevokeTasks();

  let actions: ActionsMenuItemsType = [];

  if (task.template.can_assign) {
    actions = actions.concat([
      {
        text: gt('Edit or Reassign'),
        icon: 'fa fa-edit',
        key: 'reassign',
        callback: () => setReassignModal({task, visible: true}),
      },
      {
        text: gt('Cancel task'),
        key: 'cancel',
        icon: 'fa fa-times',
        callback: () => setCancelModal({task, visible: true}),
      },
    ]);
  }
  if (task.template.can_revoke) {
    actions.push({
      text: gt('Revoke access to task'),
      key: 'revoke',
      icon: 'fa fa-times',
      callback: () => bulkRevokeTasksAccess({tasks: [task.template.url]}),
    });
  }

  return actions.length === 0 ? null : (
    <>
      <ActionsButton actions={actions} />
      {cancelModal == null ? null : (
        <CancelTaskModal
          show={cancelModal.visible}
          tasks={[cancelModal.task]}
          close={() =>
            setCancelModal((data) =>
              data != null ? {...data, visible: false} : null
            )
          }
          onClosed={() => setCancelModal(null)}
        />
      )}
      {reassignModal != null ? (
        <ReassignTaskModal
          show={reassignModal.visible}
          onToggle={() => setReassignModal(null)}
          taskInstance={reassignModal.task}
          applyToAllFutureInstances={false}
        />
      ) : null}
    </>
  );
}
